import ClusterMembershipsAPI from 'dashboard/api/clusterMemberships';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getByCluster: $state => clusterId => $state.records[clusterId] || [],
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  async get({ commit }, clusterId) {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await ClusterMembershipsAPI.get(clusterId);
      commit('setMemberships', { clusterId, records: data });
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  async create({ dispatch }, { clusterId, membership }) {
    await ClusterMembershipsAPI.create(clusterId, membership);
    await dispatch('get', clusterId);
  },

  async update({ dispatch }, { clusterId, id, membership }) {
    await ClusterMembershipsAPI.update(clusterId, id, membership);
    await dispatch('get', clusterId);
  },

  async delete({ dispatch }, { clusterId, id }) {
    await ClusterMembershipsAPI.delete(clusterId, id);
    await dispatch('get', clusterId);
  },
};

export const mutations = {
  setUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  setMemberships($state, { clusterId, records }) {
    $state.records = { ...$state.records, [clusterId]: records };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
